<main class="main">
  <mat-dialog-content>
    <h2 class="main--text">{{ 'seeCostDetail' | i18next }}</h2>
  </mat-dialog-content>
  <form [formGroup]="form" class="main--form">
    <mat-form-field class="width-standar">
      <mat-label>{{ 'requestPccTMAIMG' | i18next }}</mat-label>
      <input
        matInput
        class="content--section__select__input extern"
        formControlName="tmaimg"
        type="text"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'creationDate' | i18next }}</mat-label>
      <input
        matInput
        [matDatepicker]="creationPicker"
        formControlName="creationDate"
        readonly
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="creationPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #creationPicker (closed)="close()"></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'initialDate' | i18next }}</mat-label>
      <input
        matInput
        [matDatepicker]="initPicker"
        formControlName="initDate"
        readonly
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="initPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #initPicker (closed)="close()"></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'endDate' | i18next }}</mat-label>
      <input
        matInput
        [matDatepicker]="endPicker"
        formControlName="endDate"
        [min]="form.value.initDate"
        readonly
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="endPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker #endPicker (closed)="close()"></mat-datepicker>
    </mat-form-field>
    <button type="button" class="btn btn-search" (click)="searchCostsDetail()">
      {{ 'btnSearch' | i18next | uppercase }}
    </button>
  </form>
  <div class="table">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="tmaimg">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'requestPccTMAIMG' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.tmaimg ? element.tmaimg : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="materialType">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'materialType' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.materialType ? element.materialType : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="pressType">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'preseriesType' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.preseriesType ? element.preseriesType : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="projectType">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'projectType' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.projectType ? element.projectType : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="initDate">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'initialDate' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.validityStartDate ? element.validityStartDate : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'endDate' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.validityEndDate ? element.validityEndDate : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="preseriesCost">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'presCost' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.preserieCost ? element.preserieCost : 0 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="seriesCost">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'seriesCost' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.serieCost ? element.serieCost : 0 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="creationDate">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'createDate' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.registrationDate ? element.registrationDate : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="recordType">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'recordType' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.registerType ? element.registerType : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ceco">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'ceco' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.ceco ? element.ceco : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="activityType">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'activityType' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.activityType ? element.activityType : '-' }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      class="paginator"
      (page)="handlePageEvent($event)"
      [length]="this.dataPagination?.totalResults"
      [pageSize]="this.pageSize"
      [disabled]="false"
      [showFirstLastButtons]="false"
      [pageSizeOptions]="[]"
      [hidePageSize]="hidePageSize"
      [pageIndex]="this.dataPagination?.page - 1 || 0"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>

  <mat-dialog-actions>
    <button type="button" class="btn btn-cancel" mat-dialog-close>
      {{ 'altCancel' | i18next | uppercase }}
    </button>
    <button type="submit" class="btn" (click)="closeDialog()">
      {{ 'stepConfirm' | i18next | uppercase }}
    </button>
  </mat-dialog-actions>
</main>
